import { QuerySkeleton } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import type { FC } from "react";
import { Link } from "react-router-dom-v5-compat";

import { ManagerUseQueryReturn } from "@megaron/react-clients";
import { TicketsListValue } from "@megaron/support-contracts";

import { getStatusTagStyle, statusLabels, warsawDateTimeFormatter } from "./customerSupportTicketsListTheme";
import { getMegaraxPath } from "@megaron/megarax-uri";

type Props = {
  ticketsQuery: ManagerUseQueryReturn<TicketsListValue, unknown>;
};

export const CustomerSupportTicketsCards: FC<Props> = ({ ticketsQuery }) => {
  const theme = useTheme();
  return (
    <QuerySkeleton query={ticketsQuery} height="45px">
      {(data) =>
        data.items.length > 0 ? (
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {data.items.map((ticket) => (
              <Link
                key={ticket.id}
                to={getMegaraxPath.uri("megarax://support/tickets/id/{id}", { id: ticket.id })}
                css={{
                  textDecoration: "none",
                  color: "inherit",
                  border: `1px solid ${theme.colors.border}`,
                  borderRadius: theme.smallBorderRadius,
                  padding: "0.625rem 0.75rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.25rem",
                  background: "white",
                  "&:hover": { background: theme.colors.hover },
                }}
              >
                <span css={{ fontSize: "14px", fontWeight: 600 }}>{ticket.subject}</span>
                <div css={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "0.5rem" }}>
                  <span css={{ fontSize: "12px", color: theme.colors.secondaryText }}>
                    {warsawDateTimeFormatter.format(ticket.createdAt)}
                  </span>
                  <span
                    css={{
                      ...getStatusTagStyle(theme, ticket.status),
                      fontSize: "11px",
                      fontWeight: 700,
                      borderRadius: "999px",
                      padding: "2px 8px",
                      lineHeight: 1.4,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {statusLabels[ticket.status]}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div
            css={{
              border: `1px dashed ${theme.colors.border}`,
              borderRadius: theme.smallBorderRadius,
              minHeight: "45px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              color: theme.colors.secondaryText,
            }}
          >
            Brak zgłoszeń
          </div>
        )
      }
    </QuerySkeleton>
  );
};
